import React from 'react'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Box from '@mui/material/Box'
import useCustomStyles from '../../hooks/CustomStylesHook'
import BasicDetails from './basicDetails/BasicDetails'
import { Grid2 as Grid, useTheme } from '@mui/material'
import Members from './members/Members'
import Health from './health/Health'

const styles = (theme: any) => ({
  tabsContainer: {
    height: '5%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  tabSelected: {
    background: `${theme.palette.primary.main} !important`,
    borderRadius: '20px !important',
    transition: 'background-color 0.3s',
    color: '#FFFFFF !important',
    fontSize: '14px !important',
    minHeight: 'unset',
    textTransform: 'capitalize',
  },
  tabUnSelected: {
    color: '#6C6C6C !important',
    fontSize: '14px !important',
    minHeight: 'unset',
    textTransform: 'capitalize',
  },
  tabContentContainer: {
    flex: 1,
    overflowY: 'auto',
  },
})

const Customers = () => {
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)
  const tabs = [
    'Basic Details',
    'Package Details',
    'Health',
    'Members',
    'Documents',
    'Claims',
  ]
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }

  const RenderTab = ({ tabValue }: { tabValue: number }) => {
    switch (tabValue) {
      case 0:
        return <BasicDetails />
      case 2:
        return <Health />
      case 3:
        return <Members />

      default:
        return null
    }
  }

  return (
    <Grid container direction={'column'} spacing={1.5} height={'100%'}>
      <Grid
        display={'flex'}
        justifyContent={'center'}
        position={'sticky'}
        size={{ xs: 12 }}
        top={0}
        zIndex={1}
      >
        <Box maxWidth={{ xs: 320, sm: 440, xl: 700, md: 500 }}>
          <Tabs
            TabIndicatorProps={{
              style: { display: 'none' },
            }}
            value={value}
            onChange={handleChange}
            variant='scrollable'
            scrollButtons='auto'
            aria-label='scrollable auto tabs example'
          >
            {tabs?.map((label, index) => (
              <Tab
                key={label}
                label={label}
                className={
                  value === index
                    ? classes?.tabSelected
                    : classes?.tabUnSelected
                }
              />
            ))}
          </Tabs>
        </Box>
      </Grid>
      <Grid size={{ xs: 12 }} pr={2} className={classes?.tabContentContainer}>
        <RenderTab tabValue={value} />
      </Grid>
    </Grid>
  )
}

export default Customers
